import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import config from "../../../config";
import Header from "../../Header";
import Footer from "../../Pages/Footer";
import Connectwallet from "../Login/Connect_wallet";
import Google from "../../Pages/Presale/IconBox/Google";
import Thanks from "../Login/Thanks";
// import Selectmethod from "./Selectmethod";
import Qrcode from "../Login/Qrcode";
import "../../Pages/css/login.css";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  InputGroup,
} from "react-bootstrap";
import * as ACTIONTYPES from "../../../redux/actionTypes";
import * as Yup from "yup";
import { Formik } from "formik";
import { Spin } from "antd";
import { ERROR, Success, Warning } from "../../../utils/errors";
import { VerifyEmail, userlogin } from "../../../services/apiServices";
import { useDispatch, useSelector } from "react-redux";
import { FaRegEye } from "react-icons/fa";

const LoadingPopup = () => {
  return (
    <div className="loading-popup-container">
      <div className="loading-popup">
        <p>Please wait</p>
        <h1>Loggin in . . .</h1>
      </div>
    </div>
  );
};

const Forgotpassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showLoading, setShowLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const loginDetails = useSelector((state) => state.auth.LoginDetails);
  const forgetEmails = useSelector((state) => state.auth.ForgetEmail);

  const forgetmail = async () => {
    console.log(email, "email");
    dispatch({ type: ACTIONTYPES.ForgetEmail, payload: email });
    let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    
    let checkEmail = forgetEmails.match(regex);
  
    
    if (checkEmail == null) {
      Warning("Please enter a valid email");
      return;
    } 
    if (!email) {
      Warning("Please enter a valid email");
      return;
    }
    let res = await VerifyEmail({ email });
    console.log(res, "res");
    if (res.data.success) {
      Success("Email sent successfully");
      navigate(`${config.baseurl}changepassword`);
      return;
    } else {
      Warning("Email not registered");
      return;
    }
  };
  const inputhandler = (e) => {
    setEmail(e.target.value);
  };
  return (
    <>
      {/* <Header /> */}
      {/* <Header
        connectWalletNow={connectWalletNow}
        setconnectWalletNow={setconnectWalletNow}
      /> */}
      <section className="login-section ">
        <div className="login-container">
          <Container fluid className="px-0">
            <Row className="justify-content-center">
              <Col lg={12}>
                <Row className="">
                  <Col lg={5} md={5} xs={12} className="">
                    <div className="login-form d-lg-block d-md-block d-none">
                      <div className="">
                        <img
                          src="assets/images/coinanimation3.png"
                          alt="logo"
                          className="coinsbackImg"
                        />
                        {/* <h4>{forgetEmails}</h4> */}
                      </div>
                    </div>
                  </Col>
                  <Col lg={7} md={7} xs={12} className="">
                    <Spin spinning={showLoading}>
                      {/* <div className="loginDiv" style={{ minHeight: "368px" }}> */}
                      <div className="loginDiv">
                        <Row className="vh-100 align-items-center">
                          <Col lg={7} className="mx-auto">
                            <div className="form_content">
                              <div className="formDiv p-4">
                                <div className="text-center formheadbox">
                                  <h1 className="text-primary mb-4">
                                    Generate Your Password
                                  </h1>
                                  <p className="mb-4">
                                    <small>
                                      Enter your email address below. we will send you an email, where follow instructions”
                                    </small>
                                  </p>

                                </div>
                                <div className="mb-3">
                                  <InputGroup className=" theme-input">
                                    <Form.Control
                                      placeholder="Email"
                                      aria-label="Username"
                                      aria-describedby="basic-addon1"
                                      // helperText={errors.userName}
                                      name="userName"
                                      className="py-2"
                                      onChange={inputhandler}
                                    />
                                  </InputGroup>
                                </div>

                                <div className="text-center mt-3 ">
                                  <Button
                                    variant="custombtn2"
                                    className="py-2 w-100 fw-bold"
                                    type="submit"
                                    // href={`${config.baseurl}changepassword`}
                                    onClick={forgetmail}
                                  >
                                    Request Resent Link
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Spin>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      {/* <Footer /> */}
      {isLoading && <LoadingPopup />}
    </>
  );
};

export default Forgotpassword;
